import styles from '../style/styles/ChatInput.module.scss';
import { useChatStateStore, useUserStore, useProductsStore, useChatbotStore } from '../zustand/store';
import { useSendMessageWithWebSocket, useUserEvent } from '../services/queries/chatbotQueries';
import { 
    sendInputFocusStatus, 
    sendUserSentMessageState, 
    updateVisitHistory, 
    sendEnableChatMode 
} from '../utils/utils';
import { LayoutModeEnum, EnableModeEnum } from '../type/modeState.type';
import { getFormConfig } from '../data/formConfig';

export const ExamGroup = ({ example, index }) => {
    const { chatbot } = useChatbotStore();
    const { mutate: sendMessageWithWebSocket } = useSendMessageWithWebSocket();
    const { mutate: sendUserEvent } = useUserEvent();
    const { clearExamples } = useProductsStore();
    const { 
        setIsStreaming, 
        setIsChatbotPending, 
        currentPage, 
        layoutMode, 
        enableMode, 
        displayLocation, 
        setFormAutoStartOnce, 
        setIsFormSubmitted
    } = useChatStateStore();
    const { partnerId } = useUserStore();
    const formConfig = getFormConfig(partnerId);

    return (
        <div
            key={index}
            className={layoutMode === LayoutModeEnum.MODAL && enableMode === EnableModeEnum.SHRINK 
                ? chatbot.experimentalData?.some(data => data.key === 'csInquiry') && formConfig.triggerButtonText === example 
                    ? styles.ChatInput__suggestions__item__small__csInquiry 
                    : styles.ChatInput__suggestions__item__small
                : styles.ChatInput__suggestions__item
            }
            onMouseDown={(e) => {
                e.stopPropagation();
            }}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <p
                className='h3'
                onMouseDown={(e) => {
                    e.stopPropagation();
                }}
                onClick={(e) => {
                    if (e.target.parentElement.className.includes('ChatInput__suggestions__item__small__csInquiry')) {
                        // full mode로 확장
                        sendEnableChatMode('full');
                        // form 시작
                        setTimeout(() => {
                            setFormAutoStartOnce(true);
                            setIsFormSubmitted('ready');
                        }, 1000);
                        return;
                    }
                    const gentooStatics = JSON.parse(sessionStorage.getItem('gentoo-statics'));
                    setIsStreaming(true);
                    sendUserSentMessageState(true);
                    sendUserEvent({
                        payload: {
                            ...gentooStatics,
                            timestamp: String(Date.now()),
                            eventCategory: 'chat_input_started',
                            context: {
                                inputType: 'example_click_from_chat',
                                messageText: example,
                                messageLength: example.length,
                            },
                        },
                    });
                    sendMessageWithWebSocket({ messageInput: example, isChatbot: false, preAnswers: [] });
                    setIsChatbotPending(true);
                    sendInputFocusStatus(true);
                    clearExamples();
                    updateVisitHistory(currentPage, displayLocation);
                }}
            >{example}</p>
        </div>
    )
}